// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/pattern-background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* @tokens Colors
* @presenter Color
*/
.brand-grey-400[data-v-f03e5018] {
  color: #bdbdbd;
}
.brand-grey-500[data-v-f03e5018] {
  color: #9e9e9e;
}
.brand-grey-600[data-v-f03e5018] {
  color: #757575;
}
.brand-grey-700[data-v-f03e5018] {
  color: #616161;
}
.status-error[data-v-f03e5018] {
  color: #b00020;
}
.status-yellow[data-v-f03e5018] {
  color: #aa8a22;
}
.status-success[data-v-f03e5018] {
  color: #1eb980;
}
.status-success-grey-700[data-v-f03e5018] {
  color: #616161;
}
.text-white[data-v-f03e5018] {
  color: #fff;
}
.line[data-v-f03e5018] {
  border: 1px solid #f4f2f7;
  margin-top: 2%;
  width: 100%;
  margin-bottom: 2%;
}
@media (max-width: 767px) {
.line[data-v-f03e5018] {
    display: none;
}
}
@media (max-width: 767px) {
.mobile-line[data-v-f03e5018] {
    border: 1px solid #f4f2f7;
    margin-right: 10%;
    width: 90%;
    margin-bottom: 2%;
}
}
.modal[data-v-f03e5018] {
  left: 1%;
  position: relative;
  height: 100%;
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 30px;
}
@media (max-width: 767px) {
.modal[data-v-f03e5018] {
    display: block;
    height: 95%;
}
}
.modal-container[data-v-f03e5018] {
  height: 7%;
  width: 94%;
  margin: 3%;
}
@media (max-width: 767px) {
.modal-container[data-v-f03e5018] {
    height: 12%;
}
}
.modal-header[data-v-f03e5018] {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
.modal-header[data-v-f03e5018] {
    height: 85%;
}
}
.modal-header-container[data-v-f03e5018] {
  position: relative;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #f4f2f7;
  margin: 0;
}
@media (max-width: 767px) {
.modal-header-container[data-v-f03e5018] {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
}
}
.modal-header-container-subheading[data-v-f03e5018] {
  display: none;
}
@media (max-width: 767px) {
.modal-header-container-subheading[data-v-f03e5018] {
    display: inline-block;
    width: 100%;
    height: 25%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 80%;
    left: 0;
}
.modal-header-container-subheading > .modal-header-text[data-v-f03e5018] {
    font-size: 13px;
    white-space: nowrap;
}
}
@media (max-width: 767px) {
.modal-header-container-text[data-v-f03e5018] {
    width: 100%;
    height: 95%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 0;
    left: 0;
}
}
.modal-header-arrow[data-v-f03e5018] {
  width: 10%;
  height: 100%;
  justify-content: center;
  cursor: pointer;
}
@media (max-width: 767px) {
.modal-header-arrow-image[data-v-f03e5018] {
    width: 23px;
}
}
@media (max-width: 767px) {
.modal-header-arrow[data-v-f03e5018] {
    z-index: 99999;
    padding-top: 0;
    width: 100%;
    height: 80%;
}
}
.modal-header-logo[data-v-f03e5018] {
  display: none;
  width: 90%;
  height: 100%;
}
@media (max-width: 767px) {
.modal-header-logo[data-v-f03e5018] {
    display: flex;
    width: 100%;
    height: 45%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    background-color: transparent;
    right: 0;
    justify-content: center;
    align-items: center;
}
}
@media (max-width: 767px) {
.modal-header-logo > img[data-v-f03e5018] {
    width: 50%;
    height: 80%;
}
}
@media (max-width: 767px) {
.modal-header-progress[data-v-f03e5018] {
    height: 95%;
    width: 100%;
    margin-top: 0;
    z-index: 0;
    position: absolute;
    background-color: transparent;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    align-content: flex-end;
    flex-wrap: wrap;
}
}
@media (max-width: 767px) and (max-width: 767px) {
.modal-header-progress > img[data-v-f03e5018] {
    width: 15%;
    height: 20%;
}
}
.modal-header-text[data-v-f03e5018] {
  width: 100%;
  height: 50%;
  color: #9e9e9e;
  margin-left: 2%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  font-family: Jost, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  text-align: center;
}
@media (max-width: 767px) {
.modal-header-text[data-v-f03e5018] {
    margin-left: 0;
    display: contents;
    flex-direction: column;
    flex-wrap: nowrap;
    z-index: 0;
    background-color: transparent;
}
}
.modal-body[data-v-f03e5018] {
  position: relative;
  height: 85%;
  width: 95%;
  text-align: center;
  font-family: Jost, sans-serif;
}
@media (max-width: 767px) {
.modal-body[data-v-f03e5018] {
    width: 95%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 29px;
    margin-left: 2.5%;
}
}
.modal_text-input-container[data-v-f03e5018] {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
}
.modal_text-input-container_title[data-v-f03e5018] {
  width: 448px;
  height: 20px;
  font-family: Jost, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  padding-bottom: 10px;
}
.modal_text-input-container_title > span[data-v-f03e5018] {
  color: #757575;
  font-weight: 400;
}
.modal_text-input-container_single[data-v-f03e5018] {
  width: 100%;
  margin-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_single[data-v-f03e5018] {
    width: 95%;
}
}
.modal_text-input-container_double-column[data-v-f03e5018] {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  width: 100%;
  margin-top: 0;
  padding-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_double-column[data-v-f03e5018] {
    flex-direction: column;
    align-items: flex-start;
}
}
.modal_button-container[data-v-f03e5018] {
  margin: 2% 0;
  height: 5%;
  display: flex;
  align-items: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
@media (max-width: 767px) {
.modal_button-container[data-v-f03e5018] {
    justify-content: center;
}
}
@media (max-width: 767px) {
.modal_button-container .yc--button[data-v-f03e5018] {
    width: 100%;
}
}
@media (max-width: 767px) {
.logo[data-v-f03e5018] {
    width: 100%;
    height: 100%;
}
}
body[data-v-f03e5018] {
  margin: 0px;
  height: 100%;
}
html[data-v-f03e5018] {
  padding: 0px;
  margin: 0px;
  font-family: "Jost", sans-serif;
  line-height: 1.5;
}
.view_component[data-v-f03e5018] {
  margin: 0px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #2F1C50;
  padding-top: 72px;
  background-size: contain;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media screen and (max-height: 800px) {
.view_component[data-v-f03e5018] {
    padding-top: 15px;
}
}
.view_component-logo[data-v-f03e5018] {
  padding-bottom: 50px;
}
@media screen and (max-height: 800px) {
.view_component-logo[data-v-f03e5018] {
    padding-bottom: 5px;
}
}
@media (max-width: 768px) {
.view_component[data-v-f03e5018] {
    background-color: #fff;
    background-image: none;
    padding-top: 0;
    min-height: 800px;
    overflow-y: scroll;
}
.view_component-logo[data-v-f03e5018] {
    height: 30px;
    display: none;
}
}
.brand-grey-400[data-v-f03e5018] {
  color: #bdbdbd;
}
.brand-grey-500[data-v-f03e5018] {
  color: #9e9e9e;
}
.brand-grey-600[data-v-f03e5018] {
  color: #757575;
}
.brand-grey-700[data-v-f03e5018] {
  color: #616161;
}
.status-error[data-v-f03e5018] {
  color: #b00020;
}
.status-yellow[data-v-f03e5018] {
  color: #aa8a22;
}
.status-success[data-v-f03e5018] {
  color: #1eb980;
}
.status-success-grey-700[data-v-f03e5018] {
  color: #616161;
}
.text-white[data-v-f03e5018] {
  color: #fff;
}
.line[data-v-f03e5018] {
  border: 1px solid #f4f2f7;
  margin-top: 2%;
  width: 100%;
  margin-bottom: 2%;
}
@media (max-width: 767px) {
.line[data-v-f03e5018] {
    display: none;
}
}
@media (max-width: 767px) {
.mobile-line[data-v-f03e5018] {
    border: 1px solid #f4f2f7;
    margin-right: 10%;
    width: 90%;
    margin-bottom: 2%;
}
}
.modal[data-v-f03e5018] {
  left: 1%;
  position: relative;
  height: 100%;
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 30px;
}
@media (max-width: 767px) {
.modal[data-v-f03e5018] {
    display: block;
    height: 95%;
}
}
.modal-container[data-v-f03e5018] {
  height: 7%;
  width: 94%;
  margin: 3%;
}
@media (max-width: 767px) {
.modal-container[data-v-f03e5018] {
    height: 12%;
}
}
.modal-header[data-v-f03e5018] {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
.modal-header[data-v-f03e5018] {
    height: 85%;
}
}
.modal-header-container[data-v-f03e5018] {
  position: relative;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #f4f2f7;
  margin: 0;
}
@media (max-width: 767px) {
.modal-header-container[data-v-f03e5018] {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
}
}
.modal-header-container-subheading[data-v-f03e5018] {
  display: none;
}
@media (max-width: 767px) {
.modal-header-container-subheading[data-v-f03e5018] {
    display: inline-block;
    width: 100%;
    height: 25%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 80%;
    left: 0;
}
.modal-header-container-subheading > .modal-header-text[data-v-f03e5018] {
    font-size: 13px;
    white-space: nowrap;
}
}
@media (max-width: 767px) {
.modal-header-container-text[data-v-f03e5018] {
    width: 100%;
    height: 95%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 0;
    left: 0;
}
}
.modal-header-arrow[data-v-f03e5018] {
  width: 10%;
  height: 100%;
  justify-content: center;
  cursor: pointer;
}
@media (max-width: 767px) {
.modal-header-arrow-image[data-v-f03e5018] {
    width: 23px;
}
}
@media (max-width: 767px) {
.modal-header-arrow[data-v-f03e5018] {
    z-index: 99999;
    padding-top: 0;
    width: 100%;
    height: 80%;
}
}
.modal-header-logo[data-v-f03e5018] {
  display: none;
  width: 90%;
  height: 100%;
}
@media (max-width: 767px) {
.modal-header-logo[data-v-f03e5018] {
    display: flex;
    width: 100%;
    height: 45%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    background-color: transparent;
    right: 0;
    justify-content: center;
    align-items: center;
}
}
@media (max-width: 767px) {
.modal-header-logo > img[data-v-f03e5018] {
    width: 50%;
    height: 80%;
}
}
@media (max-width: 767px) {
.modal-header-progress[data-v-f03e5018] {
    height: 95%;
    width: 100%;
    margin-top: 0;
    z-index: 0;
    position: absolute;
    background-color: transparent;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    align-content: flex-end;
    flex-wrap: wrap;
}
}
@media (max-width: 767px) and (max-width: 767px) {
.modal-header-progress > img[data-v-f03e5018] {
    width: 15%;
    height: 20%;
}
}
.modal-header-text[data-v-f03e5018] {
  width: 100%;
  height: 50%;
  color: #9e9e9e;
  margin-left: 2%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  font-family: Jost, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  text-align: center;
}
@media (max-width: 767px) {
.modal-header-text[data-v-f03e5018] {
    margin-left: 0;
    display: contents;
    flex-direction: column;
    flex-wrap: nowrap;
    z-index: 0;
    background-color: transparent;
}
}
.modal-body[data-v-f03e5018] {
  position: relative;
  height: 85%;
  width: 95%;
  text-align: center;
  font-family: Jost, sans-serif;
}
@media (max-width: 767px) {
.modal-body[data-v-f03e5018] {
    width: 95%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 29px;
    margin-left: 2.5%;
}
}
.modal_text-input-container[data-v-f03e5018] {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
}
.modal_text-input-container_title[data-v-f03e5018] {
  width: 448px;
  height: 20px;
  font-family: Jost, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  padding-bottom: 10px;
}
.modal_text-input-container_title > span[data-v-f03e5018] {
  color: #757575;
  font-weight: 400;
}
.modal_text-input-container_single[data-v-f03e5018] {
  width: 100%;
  margin-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_single[data-v-f03e5018] {
    width: 95%;
}
}
.modal_text-input-container_double-column[data-v-f03e5018] {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  width: 100%;
  margin-top: 0;
  padding-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_double-column[data-v-f03e5018] {
    flex-direction: column;
    align-items: flex-start;
}
}
.modal_button-container[data-v-f03e5018] {
  margin: 2% 0;
  height: 5%;
  display: flex;
  align-items: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
@media (max-width: 767px) {
.modal_button-container[data-v-f03e5018] {
    justify-content: center;
}
}
@media (max-width: 767px) {
.modal_button-container .yc--button[data-v-f03e5018] {
    width: 100%;
}
}
@media (max-width: 767px) {
.logo[data-v-f03e5018] {
    width: 100%;
    height: 100%;
}
}
.modal[data-v-f03e5018] {
  padding-top: 0 !important;
  height: auto !important;
}
@media (max-width: 767px) {
.modal[data-v-f03e5018] {
    display: flex !important;
}
}
.modal-header[data-v-f03e5018] {
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.modal-header-text-custom[data-v-f03e5018] {
  color: #9e9e9e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Jost, sans-serif;
  font-size: 18px;
  font-weight: 500;
  flex-grow: 1;
}
.modal-body[data-v-f03e5018] {
  width: 100%;
  text-align: center;
  margin-bottom: 60px;
  font-family: Jost, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  align-content: flex-start;
  margin: 0;
}
.modal-body-heading[data-v-f03e5018] {
  font-family: Jost, sans-serif;
  font-size: 22px;
  font-weight: 500;
  line-height: 34px;
  letter-spacing: 0;
  text-align: center;
  padding-bottom: 12px;
}
.modal-body-description[data-v-f03e5018] {
  width: 94%;
  margin: 0 3%;
  font-family: Jost, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  padding-bottom: 8px;
  color: #616161;
}
.modal-body-text[data-v-f03e5018] {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.modal-view-footer[data-v-f03e5018] {
  width: 96%;
  margin: 2% 2% 1% 2%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
@media (max-width: 767px) {
.modal-view-footer[data-v-f03e5018] {
    margin: 2%;
}
}
.modal-view-footer .yc--button[data-v-f03e5018] {
  border-radius: 72px;
  font-family: Jost, "sans-serif";
  font-size: 16px;
  border: none !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
